module.exports = __webpack_public_path__ + "assets/static/png/plategi-red.6f79bb174b0e636ec02cff47cb317638.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/plategi-red.png
 ** module id = 518
 ** module chunks = 1
 **/